export default __webpack_public_path__ + "static/media/76temp.6f3a75fb.png";